import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IProjektStatiQuerySorter extends ISorter {
   id?: ISorterExpression;
   name?: ISorterExpression;
   beschreibung?: ISorterExpression;
}

export const ProjektStatiQuerySorterConfig: ISorterConfig = [
   SorterConfig('id', 'PROJEKTE.Models.PROJEKT_STATUS.Propertys.ID.title'),
   SorterConfig('name', 'PROJEKTE.Models.PROJEKT_STATUS.Propertys.NAME.title'),
   SorterConfig('beschreibung', 'PROJEKTE.Models.PROJEKT_STATUS.Propertys.BESCHREIBUNG.title'),
];
